import { render, staticRenderFns } from "./collaborateWorkflowForm.vue?vue&type=template&id=9b8d9386&scoped=true&"
import script from "./collaborateWorkflowForm.vue?vue&type=script&lang=js&"
export * from "./collaborateWorkflowForm.vue?vue&type=script&lang=js&"
import style0 from "./collaborateWorkflowForm.vue?vue&type=style&index=0&id=9b8d9386&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8d9386",
  null
  
)

export default component.exports